import React from "react";
import { Tabs } from "antd";
import PendingOrders from "./order/PendingOrders";
import HistoryOrders from "./order/HistoryOrders";
import ActiveOrders from "./order/ActiveOrders";

const { TabPane } = Tabs;

const Orders = () => {
  const onChange = (key) => {
    console.log(key);
  };
  const tabStyle = {
    color: "rgba(0, 0, 0, 0.65)",
    fontWeight: "600",
  };
  return (
    <>
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{ backgroundColor: "white" }}
        style={{}}
        onChange={onChange}
      >
        <TabPane tab={<span style={tabStyle}>Pending</span>} key="1">
          <>
            <PendingOrders />
          </>
        </TabPane>
        <TabPane tab={<span style={tabStyle}>Active</span>} key="2">
          <>
            <ActiveOrders />
          </>
        </TabPane>
        <TabPane tab={<span style={tabStyle}>History</span>} key="3">
          <>
            <HistoryOrders />
          </>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Orders;
